import React from 'react';
import ReactTooltip from 'react-tooltip';

import './MapBox.scss';
import FlagModal from './FlagModal';
import MapLegendModal from './MapLegendModal';
import MapImageButton from '../BulletinView/Modal/ModalContent/MapImageButton';
import SendMessageButton from '../BulletinView/SendMessageButton';

class MapBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showHelpModal: false,
      status: props.status,
      flagModalIsOpen: false,
    };
    this.updateFlagValue = this.updateFlagValue.bind(this);
  }

  toggleFlagModal = () => {
    this.setState(state => ({
      flagModalIsOpen: !state.flagModalIsOpen,
    }));
  };

  updateFlagValue() {
    const { updateFlag, variable } = this.props;
    updateFlag(variable, true);
    this.setState({
      status: {
        isUnseen: false,
        isFlagged: true,
      },
    });
  }

  toggleHelpModal() {
    this.setState(state => ({
      showHelpModal: !state.showHelpModal,
    }));
  }

  render() {
    const {
      content,
      index,
      toggleImageModal,
      disableFlag,
      noButton,
      userIsAuthenticated,
      validationEnabled,
    } = this.props;
    const { flagModalIsOpen, status, showHelpModal } = this.state;
    const mainImage = (
      <MapImageButton
        src={content.picture}
        alt={content.name}
        onClick={() => toggleImageModal(index)}
      />
    );
    const mainImageInLegend = (
      <MapImageButton
        src={content.picture}
        alt={content.name}
        onClick={() => toggleImageModal(index)}
      />
    );
    const legendImage = content?.help_text?.image ? (
      <MapImageButton
        src={content?.help_text?.image}
        alt={content.name}
        style={{ width: '100%' }}
      />
    ) : undefined;

    if (JSON.stringify(content) === '{}') {
      return (
        <div className="card bulletin-content map">
          <p className="noContentError">No picture matching the query !</p>
        </div>
      );
    }

    return (
      <>
        <MapLegendModal
          legend={content?.help_text?.legend}
          legendWarn={content?.help_text?.legend_warn}
          legendImage={legendImage}
          mainImageInLegend={mainImageInLegend}
          showHelpModal={showHelpModal}
          toggleHelpModal={() => this.toggleHelpModal()}
        />

        <div
          className={`card bulletin-content map ${
            status.isFlagged && userIsAuthenticated ? 'map-error' : ''
          }`}
        >
          {mainImage}
          {!noButton && (
            <div>
              <div className="button-left">
                {userIsAuthenticated && validationEnabled && (
                  <SendMessageButton
                    alreadySent={status.isFlagged}
                    disabled={disableFlag || content.locked}
                    onClick={this.toggleFlagModal}
                    type="map"
                    itemId={content.id}
                  />
                )}
              </div>
              <div className="button-right">
                <button
                  className="filters-button"
                  type="button"
                  disabled={!content?.help_text}
                  data-cy="map-help-button"
                  onClick={() => this.toggleHelpModal()}
                >
                  Help
                </button>
                <ReactTooltip
                  id={`help-tooltip${content.id}`}
                  globalEventOff="click"
                  className="tooltip"
                  effect="solid"
                  multiline
                />
                <a href={content.picture} download={content.name}>
                  <button className="filters-button" type="button">
                    Download
                  </button>
                </a>
              </div>
            </div>
          )}
          {!noButton ? (
            <FlagModal
              show={flagModalIsOpen}
              onCancel={this.toggleFlagModal}
              id={content.id}
              type="map"
              onSuccess={() => {
                this.toggleFlagModal();
                this.updateFlagValue();
              }}
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default MapBox;
